<div class="container-fluid">
  <div class="d-flex flex-row justify-content-between align-items-center mt-3">
    <div class="form-inline">
      <span class="badge badge-warning">
        <span class="material-icons">
          account_tree
        </span>
      </span>
      <h4 class="mt-2">Departamentos</h4>
    </div>
    <div class="btn-group" role="group" *ngIf="showDepartments">
      <button type="button" class="btn btn-info d-flex align-items-center" (click)="addDepartment()">
        <span class="material-icons">
          account_tree
        </span>
        <span>Agregar departamento</span>
      </button>
    </div>
  </div>
  <div class="container-fluid pb-3">
    <div class="d-flex flex-row justify-content-between align-items-center mt-2" *ngIf="!showDepartments">
      <button type="button" class="btn btn-secondary d-flex align-items-center" (click)="backToDepartments()">
        <span class="material-icons">
          arrow_back
        </span>
        <span>Volver a departamentos</span>
      </button>
      <h5>{{selectedDepartment.name}}</h5>
      <button type="button" class="btn btn-info d-flex align-items-center" (click)="addArea(selectedDepartment)">
        <span class="material-icons">
          category
        </span>
        <span>Agregar área</span>
      </button>
    </div>
    <div class="row mt-5" *ngIf="!showDepartments">
      <ng-container *ngFor="let area of areas; let i = index;">
        <div class="d-flex w-100 flex-row justify-content-between align-items-center mt-4">
          <h4 class="area-title">
            {{area.name}}
          </h4>
          <button class="btn btn-info" (click)="addIndicator(area)">
            <span class="material-icons">
              trending_up
            </span>
            <span>Agregar indicador</span>
          </button>
        </div>
        <div class="table-responsive mt-3">
          <table class="table table-bordered">
            <thead style="text-align: center;">
              <tr>
                <th ROWSPAN="2">Prioridad</th>
                <th ROWSPAN="2">Indicador</th>
                <th COLSPAN="3">Meta</th>
                <th ROWSPAN="2">Empieza el</th>
                <th ROWSPAN="2">Termina el</th>
                <th ROWSPAN="2"></th>
              </tr>
              <tr>
                <th>{{returnMonthFormat(currentMonth - 1)}}</th>
                <th>{{returnMonthFormat(currentMonth)}}</th>
                <th>{{returnMonthFormat(currentMonth + 1)}}</th>
            </thead>
            <tbody>
              <ng-container *ngIf="indicators[area.id]">
                <tr *ngFor="let indicator of indicators[area.id]">
                  <td>
                    {{indicator.priority}}
                  </td>
                  <td>
                    {{indicator.indicator}}
                  </td>
                  <td>
                    {{returnChangedFormat(indicator.type, indicator.monthgoal[returnMonthFormat(currentMonth - 1)])}}
                  </td>
                  <td>
                    {{returnChangedFormat(indicator.type, indicator.monthgoal[returnMonthFormat(currentMonth)])}}
                  </td>
                  <td>
                    {{returnChangedFormat(indicator.type, indicator.monthgoal[returnMonthFormat(currentMonth + 1)])}}
                  </td>
                  <td>
                    {{getDateFormat(indicator.startsAt!)}}
                  </td>
                  <td>
                    {{getDateFormat(indicator.endsAt!)}}
                  </td>
                  <td ngbTooltip="Click para editar">
                    <a class="material-icons" (click)="updateIndicator(indicator)">
                      edit
                    </a>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
    <div class="row mt-5 match-height" *ngIf="showDepartments">
      <ng-container *ngFor="let department of departments; let i = index">
        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-3">
          <div class="card card-inverse bg-info cursor-pointer h-100" (click)="selectDepartment(department, i)">
            <div class="card-content">
              <div class="card-body">
                <div class="media">
                  <div class="media-body text-left">
                    <h3 class="card-text">{{department.name}}</h3>
                    <span>{{department.ubication}}</span>
                  </div>
                  <div class="media-right align-self-center">
                    <span class="material-icons font-large-2 float-right">
                      store
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>